import { sendUpdate } from './common';
import { insideIframe, setConfirmedHostOrigin, getConfirmedHostOrigin } from './message-sender';

// The data argument should be the "data" pinia store
export default function setupMessageReceiver(data) {
    if (!insideIframe) return;

    window.addEventListener('message', function(e) {
        const confirmedHostOrigin = getConfirmedHostOrigin();
        const subject = e.data?.DRF?.subject;

        if (confirmedHostOrigin && e.origin == confirmedHostOrigin) {
            if (subject == 'update-data') {
                if (!data.loadFromStorage(e.data.DRF.dataid)) {
                    sendUpdate({
                        action: 'get-subscriptions',
                        store: data,
                    });
                }
            } else if (subject == 'viewport-update') {
                data.setViewport(e.data.DRF.viewport);
            }
        }

        // We need to be able to receive this before the host origin is confirmed,
        // because this is how we confirm it.
        if (subject == 'supports-dialog') {
            data.setSupportsDialog();
            setConfirmedHostOrigin(e.data.DRF.hostOrigin);
        }
    });

    window.parent.postMessage({
        DRF: {
            subject: 'ready',
        },
    }, '*');
}
